/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskGradingSystem } from './taskGradingSystem';

export type TaskGradingSystemProperty = TaskGradingSystem | null;
